module.exports = __webpack_public_path__ + "img/ic_housing_bureau_portfolio.6450f5fa.svg";